import React, { Component } from 'react';

class LabelBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            label: this.props.value || null,
            style: this.props.style || {},
            className: this.props.className || '',
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            label: nextProps.value || null,
            style: nextProps.style || {},
            className: nextProps.className || '',
        })
    }

    static getBadgeClassName(type) {
        let className = 'badge badge-pill '
        switch (type) {
            case 'tag':
                className += 'badge-primary'
                break
            case 'manufacturer':
                className += 'badge-info'
                break
            case 'customer-type':
                className += 'badge-custom-secondary'
                break
            case 'vendor':
                className += 'badge-warning'
                break
            case 'brand':
                className += 'badge-success'
                break
            case 'customer-tag':
                className += 'badge-danger'
                break
            case 'modified':
                className += 'badge-info'
                break
            case 'deleted':
                className += 'badge-warning'
                break
            case 'completed':
                className += 'badge-success'
                break
            case 'inProgress':
                className += 'badge-warning'
                break
            case 'in-progress':
                className += 'badge-warning'
                break
            case 'created':
                className += 'badge-info'
                break
            case 'error':
                className += 'badge-danger'
                break
        }
        return className
    }

    render() {
        if (!this.state.label) {
            return <span />
        }
        if (this.state.label.attributes) {
            return <span className={LabelBadge.getBadgeClassName(this.state.label.attributes.type) + " " + this.state.className} style={this.state.style}>
                {this.state.label.attributes.title} </span>
        } else {
            return <span className={LabelBadge.getBadgeClassName(this.state.label.type) + " " + this.state.className} style={this.state.style}>
                {this.state.label.title} </span>
        }
    }

}

export default LabelBadge





// WEBPACK FOOTER //
// ./src/common/label/badge.component.jsx